export { default as Separator } from "./Separator.vue";
